import React, { useContext, useEffect, useRef, useState } from 'react';
import { Routes, Route, Outlet, Navigate, BrowserRouter } from 'react-router-dom';
import AppContext from './contexts/AppContext'
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import Project from './pages/Project';
import Models from './pages/Models';
import authService from './authentication';
import jwtDecode from 'jwt-decode';
import ProjectInfo from './pages/ProjectInfo';
import BowtieList from './pages/BowtieList';
import ColabList from './pages/ColabList';
import AcceptInvite from './pages/AcceptInvite';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import WorkArea from './pages/WorkArea/WorkArea';
import PrioritizationInterface from './pages/PrioritizationInterface';
import Modal from './components/Modal';
import InputModal from './components/InputModal';
import Landing from './pages/Landing';
import MitigationEffectsSimulation from './pages/MitigationEffectsSimulation';

function PrivateRoute() {
  const { user } = useContext(AppContext);
  return user ? <Outlet /> : <Navigate to="/home" />;
}

function App() {
  const [user, setUser] = useState();
  const [sidebarOpen, setsidebarOpen] = useState(true);
  const [loading, setLoading] = useState(true);
  const [inputModalHidden, setInputModalHidden] = useState(true);
  const [modalHidden, setModalHidden] = useState(true);
  const [title, setTitle] = useState('')
  const [message, setMessage] = useState('')
  const [modalInputPlaceholder, setModalInputPlaceholder] = useState('')
  const [modalInputLabel, setModalInputLabel] = useState('')
  const [modalInputValue, setModalInputValue] = useState('')
  const [navHeaderText, setNavHeaderText] = useState('')
  const [acceptanceFunction, setAcceptanceFunction] = useState(()=>()=>{})

  const modalInputValueRef = useRef(modalInputValue); // Create a ref

  useEffect(() => {
    modalInputValueRef.current = modalInputValue; // Update ref whenever modalInputValue changes
  }, [modalInputValue]);

  useEffect(() => {
    try {
      const token = authService.getCurrentUser();
      if (token) {
        const u = jwtDecode(token)

        if (((u.exp * 1000) - Date.now()) < 0) {
          authService.removeCurrentUser()
          toast.info("Session Expired", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: (1000)
          });
        } else {
          setUser(u);
        }
      } else {
        toast.info("No user logged in", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: (1000)
        });
      }
    } catch (e) {
      console.warn(e);
      toast.error(e, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: (1000)
      });
    }
    setLoading(false)
  }, [])

  const openModal = (title, message, acceptanceFunction)=>{
    setModalHidden(false);
    setTitle(title);
    setMessage(message);
    setAcceptanceFunction(()=>()=>{acceptanceFunction()});
  }

  const openInputModal = (label, placeholder, acceptanceFunction)=>{
    setInputModalHidden(false);
    setModalInputLabel(label);
    setModalInputPlaceholder(placeholder);
    setAcceptanceFunction(()=>()=>{acceptanceFunction(modalInputValueRef.current)});
  }

  if (loading) {
    return null
  }

  // console.log(modalInputValue);

  return (
    <>
    <InputModal hidden={inputModalHidden} setValue={setModalInputValue} label={modalInputLabel} placeholder={modalInputPlaceholder} value={modalInputValue} acceptanceFunction={acceptanceFunction} setHidden={setInputModalHidden} title={title} message={message} />
    <Modal hidden={modalHidden} acceptanceFunction={acceptanceFunction} setHidden={setModalHidden} title={title} message={message} />
      <AppContext.Provider value={{ user, setUser, navHeaderText, setNavHeaderText, sidebarOpen, setsidebarOpen, openModal, openInputModal, modalInputValue }}>
        <BrowserRouter>
          <Routes>
            <Route path="/home" element={!user ? <Landing /> : <Navigate to="/dashboard" />} />
            <Route path="/login" element={!user ? <Login /> : <Navigate to="/dashboard" />} />
            <Route path="/signup" element={!user ? <Signup /> : <Navigate to="/dashboard" />} />

            <Route path="/" element={<PrivateRoute />}>
              <Route index element={<Dashboard />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="workarea" element={<WorkArea />} />
              <Route path="project" element={<Project />} />
              <Route path="project-info" element={<ProjectInfo />} />
              <Route path="project-info/bowties" element={<BowtieList />} />
              <Route path="project-info/colabs" element={<ColabList />} />
              <Route path="prioritization-interface" element={<PrioritizationInterface />} />
              <Route path="mitigation-effects-simulation" element={<MitigationEffectsSimulation />} />
              <Route path="models" element={<Models />} />
            </Route>

            <Route path="accept/:id" element={<AcceptInvite />} />
          </Routes>
          <ToastContainer />
        </BrowserRouter>
      </AppContext.Provider>
    </>

  );
}

export default App;
